module.exports = __webpack_public_path__ + "static/shortcut_key2-c076317a434974d88fb2a154a69f798e.jpg";